import InternalTableColumn from '@/ecm/models/internalTable/InternalTableColumn';
export default class InternalTable {
    constructor (dto) {
        this.id = null;
        this.name = '';
        this.columns = [new InternalTableColumn()];

        if (dto) {
            this.id = dto.Id;
            this.name = dto.Name;
            this.columns = dto.Columns.map(function (dto) { return new InternalTableColumn(dto); });
            if (this.columns.length == 0) {
                this.columns = [new InternalTableColumn()];
            }
        }
    }

    toDto () {
        return {
            Id: this.id,
            Name: this.name,
            Columns: this.columns,
        };
    }
}
